import { useContext } from 'react';
import { CollectionsContext } from '../contexts/complexContexts';

export const useCollections = () => {
  const context = useContext(CollectionsContext);
  if (!context) {
    throw new Error('useCollections must be used within CollectionsProvider');
  }
  return context;
};
